import { SETTINGS_INDENT_KEY } from "../../lib/constants.js";
import { computed, createBlock, createElementVNode, inject, openBlock, renderSlot, resolveComponent, withCtx } from "vue";
//#region src/components/code_editor/code_editor_indent.vue
var _hoisted_1 = ["innerHTML"];
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorIndent" }, {
	props: { level: {
		type: Number,
		default: 1,
		validator(value) {
			return value >= 0;
		}
	} },
	setup(__props) {
		const props = __props;
		const spaces = computed(() => {
			return inject(SETTINGS_INDENT_KEY).value;
		});
		const html = computed(() => {
			return "&nbsp;".repeat(props.level * spaces.value);
		});
		return (_ctx, _cache) => {
			const _component_dt_stack = resolveComponent("dt-stack");
			return openBlock(), createBlock(_component_dt_stack, { direction: "row" }, {
				default: withCtx(() => [createElementVNode("span", { innerHTML: html.value }, null, 8, _hoisted_1), renderSlot(_ctx.$slots, "default")]),
				_: 3
			});
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_indent.vue.js.map